import { render, staticRenderFns } from "./CheckSetting.vue?vue&type=template&id=19cac67a&scoped=true"
import script from "./CheckSetting.vue?vue&type=script&lang=js"
export * from "./CheckSetting.vue?vue&type=script&lang=js"
import style0 from "./CheckSetting.vue?vue&type=style&index=0&id=19cac67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cac67a",
  null
  
)

export default component.exports